import { ISubscription } from '../../http/models/models';
import { createFetchingEntity } from '../../utils/effector/creatFetchingEntity';
import UserService from '../../http/services/UserService';

export const $userSubscription = createFetchingEntity<ISubscription>({
	requestHandler: async () => (await UserService.getSubscription()).data,
	doneDataHandler: (state, payload) => payload,
	useCache: true,
});
